export default (dataSource = [], value = '') => {
  if (value.length < 1) return dataSource;

  return dataSource.filter(item => JSON.stringify(Object.values(item)).toLowerCase().search(value) > -1);
};
